import { render, staticRenderFns } from "./JobChargeRates.vue?vue&type=template&id=52af6021&scoped=true&"
import script from "./JobChargeRates.vue?vue&type=script&lang=js&"
export * from "./JobChargeRates.vue?vue&type=script&lang=js&"
import style0 from "./JobChargeRates.vue?vue&type=style&index=0&id=52af6021&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af6021",
  null
  
)

export default component.exports